var _defs, _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimationRefreshLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15081_2641",
    x1: 1.77337,
    y1: 1.83601,
    x2: 16.307,
    y2: 2.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15081_2641",
    x1: 1.77337,
    y1: 1.83601,
    x2: 16.307,
    y2: 2.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15081_2641",
    x1: 5.38406,
    y1: 7.87963,
    x2: 12.2852,
    y2: 7.97416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15081_2641",
    x1: 5.38406,
    y1: 7.87963,
    x2: 12.2852,
    y2: 7.97416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15081_2641",
    x1: 12.504,
    y1: 5.00618,
    x2: 16.4181,
    y2: 5.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15081_2641",
    x1: 12.504,
    y1: 5.00618,
    x2: 16.4181,
    y2: 5.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6788FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C366ED"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .rotating-path {\r\n        animation: rotate 2s linear infinite;\r\n        transform-origin: 11px 11px; /* Center of the SVG */\r\n      }\r\n      @keyframes rotate {\r\n        from {\r\n          transform: rotate(0deg);\r\n        }\r\n        to {\r\n          transform: rotate(360deg);\r\n        }\r\n      }\r\n    "))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_15081_2641",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74945 18.2506C3.45805 18.542 3.45648 19.0166 3.76696 19.2875C5.29841 20.6242 7.17456 21.5137 9.18912 21.8499C11.4496 22.2272 13.7716 21.889 15.8305 20.8826C17.8895 19.8762 19.5828 18.2518 20.6737 16.2363C21.7647 14.2209 22.1989 11.915 21.9157 9.64074C21.6325 7.36651 20.646 5.23752 19.0941 3.55116C17.5422 1.86479 15.5023 0.705264 13.2594 0.234535C11.0164 -0.236193 8.6825 0.00538766 6.58354 0.925534C4.71295 1.74556 3.11226 3.06803 1.95537 4.73942C1.72083 5.07827 1.83875 5.538 2.19271 5.74903C2.54667 5.96006 3.00234 5.84219 3.24047 5.50587C4.2356 4.10039 5.59695 2.98747 7.18271 2.2923C8.99691 1.49699 11.0142 1.28818 12.9529 1.69505C14.8915 2.10192 16.6546 3.10414 17.996 4.56172C19.3374 6.0193 20.19 7.85945 20.4348 9.82514C20.6796 11.7908 20.3043 13.7839 19.3613 15.5259C18.4184 17.268 16.9549 18.672 15.1752 19.5419C13.3956 20.4117 11.3886 20.704 9.4348 20.3779C7.72699 20.0929 6.13427 19.3478 4.82484 18.2293C4.5115 17.9617 4.04084 17.9592 3.74945 18.2506Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rotating-path",
    d: "M3.74945 18.2506C3.45805 18.542 3.45648 19.0166 3.76696 19.2875C5.29841 20.6242 7.17456 21.5137 9.18912 21.8499C11.4496 22.2272 13.7716 21.889 15.8305 20.8826C17.8895 19.8762 19.5828 18.2518 20.6737 16.2363C21.7647 14.2209 22.1989 11.915 21.9157 9.64074C21.6325 7.36651 20.646 5.23752 19.0941 3.55116C17.5422 1.86479 15.5023 0.705264 13.2594 0.234535C11.0164 -0.236193 8.6825 0.00538766 6.58354 0.925534C4.71295 1.74556 3.11226 3.06803 1.95537 4.73942C1.72083 5.07827 1.83875 5.538 2.19271 5.74903C2.54667 5.96006 3.00234 5.84219 3.24047 5.50587C4.2356 4.10039 5.59695 2.98747 7.18271 2.2923C8.99691 1.49699 11.0142 1.28818 12.9529 1.69505C14.8915 2.10192 16.6546 3.10414 17.996 4.56172C19.3374 6.0193 20.19 7.85945 20.4348 9.82514C20.6796 11.7908 20.3043 13.7839 19.3613 15.5259C18.4184 17.268 16.9549 18.672 15.1752 19.5419C13.3956 20.4117 11.3886 20.704 9.4348 20.3779C7.72699 20.0929 6.13427 19.3478 4.82484 18.2293C4.5115 17.9617 4.04084 17.9592 3.74945 18.2506Z",
    fill: "url(#paint0_linear_15081_2641)",
    stroke: "url(#paint1_linear_15081_2641)",
    strokeWidth: 2.8,
    mask: "url(#path-1-inside-1_15081_2641)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9885 12.1531C11.3712 12.2778 10.0511 8.77488 9.8432 7.00781C9.21953 10.9993 6.0492 12.1011 4.54199 12.1531C8.53349 12.7768 9.73925 15.9471 9.8432 17.4543C9.8432 13.837 13.2734 12.413 14.9885 12.1531Z",
    fill: "url(#paint2_linear_15081_2641)",
    stroke: "url(#paint3_linear_15081_2641)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9512 7.42994C15.8996 7.50069 15.1509 5.51394 15.033 4.51172C14.6793 6.77555 12.8812 7.40046 12.0264 7.42994C14.2902 7.78366 14.9741 9.58176 15.033 10.4366C15.033 8.385 16.9785 7.57733 17.9512 7.42994Z",
    fill: "url(#paint4_linear_15081_2641)",
    stroke: "url(#paint5_linear_15081_2641)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationRefreshLoader);
export default __webpack_public_path__ + "static/media/animation-refresh-loader.399d4e9b157cb54bc4c71770b05b590f.svg";
export { ForwardRef as ReactComponent };